<template>
  <div v-if="isMobileHeaderDisplayed" class="drawer-wrapper">
    <div class="upper-header-wrapper">
      <EMLabel size="large" color="var(--ion-color-primary)" :bolder="true">WARD</EMLabel>
      <EMLabel class="label-subtitle" size="medium" color="#c3a342" :bolder="true"
        >School for Good, School for Life</EMLabel
      >
    </div>
    <div class="lower-header-wrapper">
      <UserRoutesGrid
        :user-routes="displayRoutes"
        @route-click="handleLinkClick"
        :is-expanded="true"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import UserRoutesGrid from '@/layouts/components/UserRoutesGrid.vue';
import EMLabel from '@/common/components/ui/label/EMLabel.vue';
import { useUserRoutes } from '@/common/composables/useUserRoutes';
import { useLayoutStore } from '@/layouts/stores/layoutStore';
import { storeToRefs } from 'pinia';

const { displayRoutes } = useUserRoutes();
const layoutStore = useLayoutStore();
const { isMobileHeaderDisplayed } = storeToRefs(layoutStore);

const emit = defineEmits<{
  (e: 'close'): void;
}>();

function handleLinkClick() {
  emit('close');
}
</script>

<style scoped>
.drawer-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  width: 100%;
  height: var(--webMobile-topbar-height);
  flex-direction: column;
  background: var(--ion-background-color);
  z-index: 1000;
  border-radius: 0 0 24px 24px;
}

.upper-header-wrapper {
  width: 100%;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding: 10px 0;
}

.lower-header-wrapper {
  width: 100%;
  border-top: 2px solid var(--ion-input-border-color);
  border-bottom: 2px solid var(--ion-input-border-color);
  padding: 8px 0 0 0;
  border-radius: 0 0 24px 24px;
}

.label-subtitle {
  margin-left: 8px;
  padding-bottom: 2px;
  font-family: 'Parisienne', cursive;
}
</style>
